import { Reducer } from 'redux'
import { NAVBAR, TYPES } from './types'
import { AnyAction } from 'models/types'

const INITIAL_STATE: NAVBAR = {
  token: '',
  openToken: false,
  visualizaToken: false,
  nomeUsuario: '',
  usuarioSelected: '',
  usuariosInstiuicao: [],
  modalAssociarDesassociar: false,
  acaoModalAssociar: 'associar',
  ramalAssociado: {
    empresa: '',
    ramal: '',
    associado: false
  },
  acaoModalPausarAgente: 'pausar',
  modalPausarAgente: false,
  motivosPausas: [],
  motivoPausaId: '',
  statusAgente: {
    agente: '',
    pausado: false,
    horarioPausa: null
  }
}

const reducer: Reducer<NAVBAR, AnyAction> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.TOGGLE_TOKEN:
      return { ...state, openToken: !state.openToken }
    case TYPES.SET_TOKEN:
      return { ...state, token: action.value }
    case TYPES.CLEAN_TOKEN:
      return { ...state, token: INITIAL_STATE.token }
    case TYPES.SET_VISUALIZACAO_TOKEN:
      return { ...state, visualizaToken: !state.visualizaToken }
    case TYPES.SET_NOME_USUARIO:
      return { ...state, nomeUsuario: action.value }
    case TYPES.SET_USUARIO_SELECTED:
      return { ...state, usuarioSelected: action.value }
    case TYPES.CLEAN_USUARIO_SELECTED:
      return { ...state, usuarioSelected: INITIAL_STATE.usuarioSelected }
    case TYPES.SET_USUARIOS_INSTITUICAO:
      return { ...state, usuariosInstiuicao: action.value }
    case TYPES.SET_RAMAL_ASSOCIADO:
      return {
        ...state,
        ramalAssociado: action.value
      }
    case TYPES.TOGGLE_MODAL_ASSOCIAR_DESASSOCIAR:
      return {
        ...state,
        modalAssociarDesassociar: action.value
      }
    case TYPES.SET_ACAO_MODAL_ASSOCIAR_DESASSOCIAR:
      return {
        ...state,
        acaoModalAssociar: action.value
      }
    case TYPES.TOGGLE_MODAL_PAUSAR_AGENTE:
      return {
        ...state,
        modalPausarAgente: action.value
      }
    case TYPES.SET_ACAO_MODAL_PAUSAR_AGENTE:
      return {
        ...state,
        acaoModalPausarAgente: action.value
      }
    case TYPES.SET_MOTIVOS_PAUSA:
      return {
        ...state,
        motivosPausas: action.value
      }
    case TYPES.SET_MOTIVO_PAUSA_ID:
      return {
        ...state,
        motivoPausaId: action.value
      }
    case TYPES.SET_STATUS_AGENTE:
      return {
        ...state,
        statusAgente: action.value
      }
    case TYPES.SET_STATUS_AGENTE_CRONOMETRO:
      return {
        ...state,
        statusAgente: action.value
      }
    case TYPES.CLEAN_MOTIVOS_PAUSA:
      return {
        ...state,
        motivoPausaId: action.value
      }
    default:
      return state
  }
}

export default reducer
